import { CategoryDisplayName } from '@oxappsec/ox-consolidated-categories';
import { createAsyncState } from 'async-utils';
import { createStore } from 'store-utils';
import { Issue } from '../../common/types/issues-types';

export const initialTopIssuesStoreValues = {
  topIssues: [],
  topIssuesCategory: [],
  categoriesFilters: [],
  loadingIssues: createAsyncState(),
  filterBy: {},
  totalIssues: 0,
};

const TopIssuesStore = createStore<IssuesStoreState>(
  initialTopIssuesStoreValues,
  'Top Issues Store',
);

export interface IssuesStoreState {
  topIssues: Issue[];
  topIssuesCategory: Issue[];
  categoriesFilters: CategoryDisplayName[];
  loadingIssues: ReturnType<typeof createAsyncState>;
  filterBy: {};
  totalIssues: number;
}

export default TopIssuesStore;
